export interface IRecordUserSettings {
    userFurtherEducationArhiveExpiredDurationInMonths: number;
    rowId: string;
}

export class RecordUserSettings implements IRecordUserSettings {
    userFurtherEducationArhiveExpiredDurationInMonths: number;
    rowId: string;

    constructor();
    constructor(obj: IRecordUserSettings);
    constructor(obj?: any) {
        this.userFurtherEducationArhiveExpiredDurationInMonths = obj && obj.userFurtherEducationArhiveExpiredDurationInMonths || 0;
        this.rowId = obj && obj.rowId || "";
    }
}